export const ROLES = {
    Admin: 'admin',
    User: 'user'
}